import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
export default function withFlags(Component) {
    function WrappedComponent(props) {
        const flags = useFlags();
        return React.createElement(Component, Object.assign({}, props, { flags: flags }));
    }
    WrappedComponent.displayName = `withFlags(${Component.displayName || Component.name || 'Component'})`;
    return WrappedComponent;
}
